import Vue from "vue";
import Router from "vue-router";
import MainHeadBar from "./layout/MainHeadBar.vue";
import MainFooterBar from "./layout/MainFooterBar.vue";
import Index from "./views/Index.vue";
import Meeting from "./views/Meeting.vue";
import GuestRooms from "./views/GuestRooms.vue";
import Kitchen from "./views/Kitchen.vue";
import Packages from "./views/Packages.vue";
import Activities from "./views/Activities.vue";
import ContactUs from "./views/ContactUs.vue";
import ChooseMeetingDate from "./views/ChooseMeetingDate.vue";
import ShowMeetingList from "./views/ShowMeetingList.vue";
import ReservationMeeting from "./views/ReservationMeeting.vue";
import InfoMeetingConfirm from "./views/InfoMeetingConfirm.vue";
import ChooseGuestDate from "./views/ChooseGuestDate.vue";
import ShowGuestList from "./views/ShowGuestList.vue";
import ReservationGuest from "./views/ReservationGuest.vue";
import InfoGuestConfirm from "./views/InfoGuestConfirm.vue";
import InfoGuestConfirmNoRe from "./views/InfoGuestConfirmNoRe.vue";
import CompleteMeetOrder from "./views/CompleteMeetOrder.vue";
import CompleteGuestOrder from "./views/CompleteGuestOrder.vue";
import ManageMeetingRoom from "./views/ManageMeetingRoom.vue";
import ManageGuestRoom from "./views/ManageGuestRoom.vue";
import MeetingHistory from "./views/MeetingHistory.vue";
import GuestHistory from "./views/GuestHistory.vue";
// import MainFooter from "./layout/MainFooter.vue";
// import Landing from "./views/Landing.vue";
// import Origin from "./views/originIndex.vue";
import Login from "./views/Login.vue";
// import Profile from "./views/Profile.vue";

Vue.use(Router);

export default new Router({
  mode:"history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "index",
      components: { default: Index, header: MainHeadBar, footer: MainFooterBar },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/meetingRooms",
      name: "meetingRooms",
      components: { default: Meeting, header: MainHeadBar, footer: MainFooterBar },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/guestRooms",
      name: "guestRooms",
      components: { default: GuestRooms, header: MainHeadBar, footer: MainFooterBar },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/kitchen",
      name: "kitchen",
      components: { default: Kitchen, header: MainHeadBar, footer: MainFooterBar },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/packages",
      name: "packages",
      components: { default: Packages, header: MainHeadBar, footer: MainFooterBar },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/activities",
      name: "activities",
      components: { default: Activities, header: MainHeadBar, footer: MainFooterBar },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/contactus",
      name: "contactus",
      components: { default: ContactUs, header: MainHeadBar, footer: MainFooterBar },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/chooseMeetingDate",
      name: "chooseMeetingDate",
      components: { default: ChooseMeetingDate, header: MainHeadBar, footer: MainFooterBar },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      },
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/showMeetingList/:id",
      name: "showMeetingList",
      components: { default: ShowMeetingList, header: MainHeadBar, footer: MainFooterBar },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      },
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/reservationMeeting",
      name: "reservationMeeting",
      components: { default: ReservationMeeting, header: MainHeadBar, footer: MainFooterBar },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/infoMeetingConfirm/:id",
      name: "infoMeetingConfirm",
      components: { default: InfoMeetingConfirm, header: MainHeadBar, footer: MainFooterBar },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      },
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/chooseGuestDate",
      name: "chooseGuestDate",
      components: { default: ChooseGuestDate, header: MainHeadBar, footer: MainFooterBar },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      },
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/showGuestList/:id",
      name: "showGuestList",
      components: { default: ShowGuestList, header: MainHeadBar, footer: MainFooterBar },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      },
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/reservationGuest",
      name: "reservationGuest",
      components: { default: ReservationGuest, header: MainHeadBar, footer: MainFooterBar },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/infoGuestConfirm/:id",
      name: "infoGuestConfirm",
      components: { default: InfoGuestConfirm, header: MainHeadBar, footer: MainFooterBar },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      },
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/infoGuestConfirmNoRe/:id",
      name: "infoGuestConfirmNoRe",
      components: { default: InfoGuestConfirmNoRe, header: MainHeadBar, footer: MainFooterBar },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      },
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/completeMeetOrder",
      name: "completeMeetOrder",
      components: { default: CompleteMeetOrder }
    },
    {
      path: "/completeGuestOrder",
      name: "completeGuestOrder",
      components: { default: CompleteGuestOrder }
    },
    //, {
    //   path: "/landing",
    //   name: "landing",
    //   components: { default: Landing, header: MainHeadBar, footer: MainFooterBar },
    //   props: {
    //     header: { colorOnScroll: 400 },
    //     footer: { backgroundColor: "black" }
    //   }
    // },
    {
      path: "/login",
      name: "login",
      components: { default: Login, header: MainHeadBar },
      props: {
        header: { colorOnScroll: 400 }
      }
    },
    {
      path: "/manageMeetingRoom",
      name: "manageMeetingRoom",
      components: { default: ManageMeetingRoom, header: MainHeadBar, footer: MainFooterBar },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      },
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/manageGuestRoom",
      name: "manageGuestRoom",
      components: { default: ManageGuestRoom, header: MainHeadBar, footer: MainFooterBar },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      },
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/meetingHistory",
      name: "meetingHistory",
      components: { default: MeetingHistory, header: MainHeadBar, footer: MainFooterBar },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      },
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/guestHistory",
      name: "guestHistory",
      components: { default: GuestHistory, header: MainHeadBar, footer: MainFooterBar },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      },
      meta: {
        keepAlive: true
      }
    }
    // {
    //   path: "/profile",
    //   name: "profile",
    //   components: { default: Profile, header: MainHeadBar, footer: MainFooterBar },
    //   props: {
    //     header: { colorOnScroll: 400 },
    //     footer: { backgroundColor: "black" }
    //   }
    // },
    // {
    //   path: "/origin",
    //   name: "origin",
    //   components: { default: Origin, header: MainNavbar, footer: MainFooter },
    //   props: {
    //     header: { colorOnScroll: 400 },
    //     footer: { backgroundColor: "black" }
    //   }
    // }
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
